import { useState } from 'react'

import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import LoginTemplate from 'src/ui/templates/Login'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import WrappedCheckbox from 'src/ui/atoms/Checkbox/Wrapped'
import Button from 'src/ui/atoms/Button'
import GoogleLogin from 'src/pages/Login/GoogleLogin'
import useLoginApi, { ILoginCredentials } from './useLoginApi'

const Login = () => {
  const navigate = useNavigate()
  const [errorCode, setErrorCode] = useState(0)
  const { login } = useLoginApi()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleLogin = async ({ email, password, remember }: ILoginCredentials) => {
    setErrorCode(0)

    try {
      await login({ email, password, remember })

      navigate('/dashboard')
    } catch (error) {
      //@ts-ignore
      if (error.response && error.response.status) {
        //@ts-ignore
        setErrorCode(error.response.status)
      }
    }
  }

  const errorText =
    errorCode === 401 || errorCode === 401
      ? 'Incorrect email address or password'
      : 'Internal Server Error'
  return (
    <LoginTemplate>
      <div className="flex flex-col justify-between py-12">
        <h1 className="mb-2 text-center text-white">Welcome back to ZoidCore</h1>
        <span className="mb-6 text-center text-white text-opacity-50">
          Don't have an account?{' '}
          <span className="cursor-pointer text-main-blue" onClick={() => navigate('/register')}>
            Sign up
          </span>
        </span>
        <form
          className="grid gap-8"
          onSubmit={handleSubmit((data) => handleLogin(data as ILoginCredentials))}>
          <div className="grid gap-4">
            <WrappedInput
              placeholder="your_email@mail.com"
              label="Email"
              error={errors.email}
              labelPosition="inside"
              type="email"
              dataCy="email"
              {...register('email', {
                required: 'Required field',
                pattern: {
                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                  message: 'Incorrect email',
                },
              })}
            />
            <WrappedInput
              placeholder="AwesomePassword123!"
              label="Password"
              error={errors.password}
              labelPosition="inside"
              type="password"
              dataCy="password"
              eye
              {...register('password', {
                required: 'Required field.',
                pattern: {
                  value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                  message:
                    'Password must contain at least 8 characters, uppercase letter and a symbol',
                },
              })}
            />

            <div className="flex items-center justify-between">
              <WrappedCheckbox size="M" value="remember" {...register('remember')}>
                Remember me
              </WrappedCheckbox>
              <span
                className="cursor-pointer text-sm text-main-blue"
                data-cy="forgot-password"
                onClick={() => navigate('/forgot-password')}>
                Forgot password
              </span>
            </div>
          </div>

          {errorCode ? <span className="text-sm text-red">{errorText}</span> : null}
          <Button name="Login" disabled={!isValid} dataCy="login" />
        </form>
        <span className="my-2 text-center text-white">or</span>
        <GoogleLogin
          text="Login with google"
          handleLoginError={(error: any) => setErrorCode(error.response.status)}
        />
      </div>
    </LoginTemplate>
  )
}

export default Login
